import { render, staticRenderFns } from "./CellRendererActivate.vue?vue&type=template&id=71887a5d&"
import script from "./CellRendererActivate.vue?vue&type=script&lang=js&"
export * from "./CellRendererActivate.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererActivate.vue?vue&type=style&index=0&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports